export default __webpack_public_path__ + "static/media/workouttimes_5@3x.674c874d.jpg";